import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SponsorCapturedLead, SponsorScanContext, SponsorScanState } from '~/types/SponsorScan';

const initialState: SponsorScanState = {
	status: 'idle',
	sponsor: null,
	selectedRepresentativeId: null,
	lastCaptured: null,
	error: null,
	capturing: false,
};

export const sponsorScanSlice = createSlice({
	name: 'sponsorScan',
	initialState,
	reducers: {
		bootstrapStart: state => {
			state.status = 'loading';
			state.error = null;
		},
		bootstrapSucceeded: (state, action: PayloadAction<SponsorScanContext>) => {
			state.status = 'loaded';
			state.sponsor = action.payload;
			state.error = null;
		},
		bootstrapFailed: (state, action: PayloadAction<string>) => {
			state.status = 'error';
			state.error = action.payload;
		},
		setSelectedRepresentative: (state, action: PayloadAction<string | null>) => {
			state.selectedRepresentativeId = action.payload;
		},
		captureStart: state => {
			state.capturing = true;
			state.error = null;
		},
		captureSucceeded: (
			state,
			action: PayloadAction<{ lead: SponsorCapturedLead; deduped: boolean }>,
		) => {
			state.capturing = false;
			state.lastCaptured = action.payload;
		},
		captureFailed: (state, action: PayloadAction<string>) => {
			state.capturing = false;
			state.error = action.payload;
		},
		clearLastCaptured: state => {
			state.lastCaptured = null;
		},
		reset: () => initialState,
	},
});

export const {
	bootstrapStart,
	bootstrapSucceeded,
	bootstrapFailed,
	setSelectedRepresentative,
	captureStart,
	captureSucceeded,
	captureFailed,
	clearLastCaptured,
	reset,
} = sponsorScanSlice.actions;
